import * as maptalks from 'maptalks';

export class ZoomControl extends maptalks.control.Zoom {

    constructor(configSettings) {
        super(configSettings);
    }
}